import * as types from "@/store/mutation-types";
import axios from "axios";

export async function requireAuth({ commit, dispatch }, payload) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + payload;
  axios
    .get(process.env.URL_SSO_API + "user/me")
    .then(response => {
      commit("IS_LOGGED");
      // console.log(response.data)
      commit("SET_CONNECT_USER_ID", response.data.id);
      commit("SET_CONNECT_USER_EMAIL", response.data.email);
      window.location = "/admin";
    })
    .catch(error => {
      // console.log(error)
      window.location = process.env.URL_SSO_FRONT;
    });
}

export function logout({ commit }) {
  commit(types.LOGOUT);
}

export function setInitSearch({ commit }) {
  commit(types.SET_INIT_SEARCH, "");
}

export function setIdEntrepriseIdPlateforme({ commit }, payload) {
  // console.log(payload)
  commit("SET_ID_ENTREPRISE", payload.idEntreprise);
  commit("SET_ID_PLATEFORME", payload.idPlateforme);
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js